import { makeStyles } from '@material-ui/core'

export interface StatusStyles {
  status: boolean;
}

export const useStyles = makeStyles((theme) => ({
  statusWrapper: {
    padding: 8,
    opacity: 0.7,
    borderRadius: 4,
    color: theme.palette.text.primary,
  },

}))
